import { ChannelType } from 'api/ChannelsAPI';
import { MessageMedium } from 'constants/messageMediums';
import { MediumConfig } from '../../types';
import {
  ConfigByMediumSerialized,
  FrequencyManagementMessageType,
} from 'modules/frequencyManagement/lib/types';
import { isFrequencyManaged, isMessageMediumSupported } from '../../commonUtils';

export const readMediumConfig = (
  data: ConfigByMediumSerialized | undefined,
  messageMedium: MessageMedium,
): MediumConfig | undefined => data?.currentProject?.settings?.frequencyManagement?.[messageMedium];

export const createIsMessageMediumFrequencyManaged =
  (data: ConfigByMediumSerialized) => (messageMedium: MessageMedium) => {
    const mediumConfig = readMediumConfig(data, messageMedium);
    if (!mediumConfig) return false;

    if (!isMessageMediumSupported(messageMedium)) return false;

    const { settings, isConfiguredForSending } = mediumConfig;
    return isConfiguredForSending && !!settings?.mode && isFrequencyManaged(settings.mode);
  };

export const isMessageChannelFrequencyManagementEligible = (
  channelType: ChannelType,
  messageMedium: MessageMedium,
) => channelType === ChannelType.Marketing && isMessageMediumSupported(messageMedium);

export const createIsMessageTypeFrequencyManaged =
  (data: ConfigByMediumSerialized) => (messageTypeId: number, messageMedium: MessageMedium) => {
    const mediumConfig = readMediumConfig(data, messageMedium);
    if (!mediumConfig) return false;

    if (!isMessageMediumSupported(messageMedium)) return false;

    const { messageTypes } = mediumConfig;
    const messageType = messageTypes.find(
      (mt: FrequencyManagementMessageType) => mt.id === messageTypeId,
    );
    if (!messageType) return false;

    const {
      frequencyManagement: { settings },
    } = messageType;
    return !!settings?.mode && isFrequencyManaged(settings.mode);
  };
